import { commerceNav } from "./commerceModules";

export const superAdminNavigations = [
  {
    id: "0",
    title: "Dashboard",
    icon: "dashboard",
    link: "/",
    match: "exact",
  },
  // {
  //   id: "1",
  //   title: "Orders",
  //   icon: "orders",
  //   link: "/order",
  //   divider: true,
  // },
  {
    id: "10",
    title: "Cart Bundle Orders",
    icon: "orders",
    link: "/cartBundleOrders",
    divider: true,
  },
  {
    id: "2",
    title: "Inventory",
    icon: "package_2",
    link: "/products",
  },

  {
    id: "3",
    title: "Offers",
    icon: "timeline",
    link: "/offer",
  },
  {
    id: "4",
    title: "Customers",
    icon: "box_add",
    link: "/customers",
    divider: true,
  },
  {
    id: "5",
    title: "Reviews",
    icon: "verified",
    link: "/reviews",
  },
  {
    id: "6",
    title: "User Management",
    icon: "groups",
    link: "/userManagement",
  },
  {
    id: "7",
    title: "Banner",
    icon: "database",
    link: "/banner",
    divider: true,
  },
  // {
  //   id: "8",
  //   title: "Blogs",
  //   icon: "image",
  //   link: "/blog",
  // },
  // {
  //   id: "8a",
  //   title: "Blog Categories",
  //   icon: "category",
  //   link: "/blogCategories",
  // },
  // {
  //   id: "8a",
  //   title: "Blog Categories",
  //   icon: "category",
  //   link: "/blogCategories",
  // },
  {
    id: "8",
    title: "Blogs Manage",
    icon: "image",
    // subMenu: [
    //   { id: "8-1", title: "Blogs Categories", link: "/blogCategories" },
    //   { id: "8-2", title: "Blogs", link: "/blog" },
    // ],
    children: [
      { id: "8-1", title: "Blogs Categories", link: "/blogCategories" },
      { id: "8-2", title: "Blogs", link: "/blog" },
    ],
  },
  {
    id: "9",
    title: "Leads",
    icon: "description",
    link: "/leads",
  },
    {
    id: "11",
    title: "Raise Tickets",
    icon: "settings",
    link: "/raiseTicket",
  },
  {
    id: "7",
    title: "State",
    icon: "edit_location_alt",
    link: "/state",
  },
  {
    id: "12",
    title: "Commerce",
    icon: "storefront",
    subMenu: commerceNav,
  },
  {
    id: "10",
    title: "Settings",
    icon: "settings",
    link: "/setting",
  },
];

export const dispatcherNavigations = [
  // {
  //   id: "1",
  //   title: "Orders",
  //   icon: "dashboard",
  //   link: "/dispatcherorder",
  // },
  {
    id: "3",
    title: "Cart Bundle Orders",
    icon: "orders",
    link: "/cartBundleOrdersDispatcher",
  },
  {
    id: "2",
    title: "Settings",
    icon: "settings",
    link: "/setting",
  },
];

export const packagerNavigations = [
  // {
  //   id: "1",
  //   title: "Orders",
  //   icon: "dashboard",
  //   link: "/packagerorder",
  // },
  {
    id: "3",
    title: "Cart Bundle Orders",
    icon: "orders",
    link: "/cartBundleOrdersPackager",
  },
  {
    id: "2",
    title: "Settings",
    icon: "settings",
    link: "/setting",
  },
];
